import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AddSquareLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M11 3.5h2c1.9 0 3.274 0 4.322.142 1.034.139 1.675.406 2.153.883.477.478.744 1.119.883 2.153C20.5 7.726 20.5 9.1 20.5 11v2c0 1.9 0 3.274-.142 4.322-.139 1.034-.406 1.675-.883 2.153-.478.477-1.119.744-2.153.883-1.048.141-2.422.142-4.322.142h-2c-1.9 0-3.274 0-4.322-.142-1.034-.139-1.675-.406-2.153-.883-.477-.478-.744-1.119-.883-2.153C3.5 16.274 3.5 14.9 3.5 13v-2c0-1.9 0-3.274.142-4.322.139-1.034.406-1.675.883-2.153.478-.477 1.119-.744 2.153-.883C7.726 3.5 9.1 3.5 11 3.5Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M12 8v8M16 12H8" })));
}
const AddSquareLight = forwardRef(_AddSquareLight);
export { AddSquareLight };
